import { AllowedConnectorTypes } from '../config/allowed-connector-types';
import { AllowedStatementTypes } from '../config/allowed-statement-types';
import { addReferencedConnectorID } from '../utils/statement';

export const onConnect = (reactflow) => (params) => {
  const { source, target } = params;
  const sourceNode = reactflow.getNode(source);
  const targetNode = reactflow.getNode(target);

  if (areAlreadyConnected(sourceNode, targetNode)) {
    return;
  }
  // check if sourceNode is a connector (but not localFileImporter) and targetNode is a statement
  if (
    AllowedConnectorTypes.includes(sourceNode.type) &&
    sourceNode.type !== 'localFileImporter' &&
    AllowedStatementTypes.includes(targetNode.type)
  ) {
    const { data } = addReferencedConnectorID(targetNode, sourceNode.id);

    updateNodeData(reactflow, targetNode.id, data);
  }
  // check if sourceNode is a statement and targetNode is a also a statement, then where the sourceNode is a dataframe, update the @ref-dataframe-id with the targetNode.id
  if (
    AllowedStatementTypes.includes(sourceNode.type) &&
    AllowedStatementTypes.includes(targetNode.type)
  ) {
    if (sourceNode.type === 'dataframe') {
      const updatedStatementNode = {
        ...targetNode.data,
        '@ref-dataframe-id': sourceNode.id,
        '@ref-dataframe': sourceNode.data['data-frame'],
      };
      reactflow.updateNodeData(target.id, updatedStatementNode, {
        replace: true,
      });
    }
  }
};

const areAlreadyConnected = (sourceNode, targetNode) => {
  const connectedDataframeIds = targetNode?.data?.['@ref-dataframe-id']?.split(',') || [];
  const connectedConnectorIds = targetNode?.data?.['@ref-connector-id']?.split(',') || [];

  return (
    connectedConnectorIds.includes(sourceNode.id) || connectedDataframeIds.includes(sourceNode.id)
  );
};

const updateNodeData = (reactflow, nodeId, newData) => {
  const { setNodes } = reactflow;

  setNodes((nodes) => {
    return nodes.map((node) => {
      if (node.id === nodeId) {
        return {
          ...node,
          data: {
            ...node.data,
            ...newData,
          },
        };
      }
      return node;
    });
  });
};
